import { getMetrics } from '../services';
export const fetchMetrics = (dates, typeMetrics) => getMetrics(dates, typeMetrics).then(response => formattedMetrics(response));
const formattedMetrics = ({ data }) => {
    const metrics = data.data;
    let result;
    if (metrics && metrics.labels.length) {
        result = {
            labels: metrics.labels || [],
            metrics: metrics.metrics || [],
        };
    }
    else {
        result = null;
    }
    return result;
};
